import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
  name: 'scrDate'
})
export class ScrDatePipe implements PipeTransform {

  transform(value: Date | string | number | undefined): string | null {
    if (!value) {
      return null;
    }
    return formatDate(value, 'M/d/yyyy', navigator.language);
  }
}

@Pipe({
  name: 'scrDatePending'
})
export class ScrDatePendingPipe implements PipeTransform {

  transform(value: Date | string | number | undefined): string | null {
    if (value == null) {
      return 'Pending';
    }
    return formatDate(value, 'M/d/yyyy', navigator.language);
  }
}

@Pipe({
  name: 'industryMonReport'
})
export class IndustryMonReportPipe implements PipeTransform {

  transform(value: Date | string | number): string | null | undefined {
    return formatDate(value, 'MMMM y', navigator.language);
  }
}

@Pipe({
  name: 'scrDateTime'
})
export class ScrDateTimePipe implements PipeTransform {

  transform(value: Date | string | number | undefined): string | null {
    if (!value) {
      return null;
    }
    return formatDate(value, 'M/d/yyyy hh:mm:ss a', navigator.language);
  }
}
